import { TextField, Paper, Table, TableHead, TableRow, TableCell, TableBody, TablePagination, Box } from "@mui/material";
import Wrapper from "../components/Wrapper";
import { useEffect, useState } from "react";
import { listBookings } from "../services/bookings";
import moment from "moment";

const Bookings = () => {

  const [bookings, set_bookings] = useState([]);
  const [page, set_page] = useState(0);
  const [count, set_count] = useState(0);
  const [search, set_search] = useState('');

  const getData = async () => {
    const { data } = await listBookings({
      page: page,
      limit : 10
    });

    set_bookings(data.data);
    set_count(data.total_records);
  }

  const handleChangePage = (event, page_no) => {
    set_page(page_no)
  }

  useEffect(() => {
    getData();

    // eslint-disable-next-line
  }, [page, search])

  return(
    <Wrapper>
      <Box
        component='div'
        display='flex'
        justifyContent='space-between'
        alignItems='center'
      >
        <TextField
          label='Search'
          sx={{
            width: '450px'
          }}
          value={search}
          onChange={(e) => set_search(e.target.value)}
        />
      </Box>

      <Paper
        elevation={4}
        sx={{
          marginTop : '20px'
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                Sr No.
              </TableCell>
              <TableCell>
                Customer Name
              </TableCell>
              <TableCell>
                Service Name
              </TableCell>
              <TableCell>
                Provided By
              </TableCell>
              <TableCell>
                Booking Time
              </TableCell>
              <TableCell>
                Created At
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {
              bookings.map((booking, ind) => {
                return(
                  <TableRow key={booking._id}>
                    <TableCell>
                      {ind + 1}
                    </TableCell>
                    <TableCell>
                      {booking.created_by_user.name}
                    </TableCell>
                    <TableCell>
                      {booking.service.name}
                    </TableCell>
                    <TableCell>
                      {booking.price} Rs / {booking.price_per}
                    </TableCell>
                    <TableCell>
                      {moment(booking.booking_date_time).format('DD-MM-YYYY hh:mm A')}
                    </TableCell>
                    <TableCell>
                      {moment(booking.created_at).format('DD-MM-YYYY hh:mm A')}
                    </TableCell>
                  </TableRow>
                )
              })
            }
          </TableBody>
        </Table>

        <TablePagination
          component="div"
          count={count}
          page={page}
          rowsPerPage={10}
          rowsPerPageOptions={[]}
          onPageChange={handleChangePage}
        />
      </Paper>

    </Wrapper>
  )
}

export default Bookings;